var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-color"},_vm._l((_vm.colors),function(color){return _c('color',{key:color.id,attrs:{"color":color.id,"selected":color.id === _vm.value},on:{"select":function($event){return _vm.select(color.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }